<div class="text-center my-5">
  <fgbcl-loading></fgbcl-loading>
  <p class="my-2">
    <em>{{ 'fgbcl.registration.payment.callback.page.title' | translate }}</em>
  </p>
  <p class="my-2 font-size-12">
    <em>{{ 'fgbcl.registration.payment.callback.page.description' | translate }}</em>
  </p>
</div>
